import React from 'react';
import styled from 'styled-components';
import FullSizeTile from '../../shared/FullSizeTile';

const SingleViewHeader = styled.div`
  width: 600px;
  display: block;
  margin: 0 auto;
`;

const Link = styled.a``;

const BoardLogo = styled.img`
  margin-top: 10px;
  height: 40px;
`;

const TileSingleView = ({ ctrl, organization }) => {
  return (
    <>
      <SingleViewHeader>
        <Link
          href={`/?utm_campaign=${ctrl.exploreOrPublic}_single_tile&utm_source=${ctrl.tile.headline}`}
        >
          <BoardLogo src={ctrl.boardImage} />
        </Link>
      </SingleViewHeader>
      <FullSizeTile
        tile={ctrl.tile}
        organization={organization}
        demo={ctrl.demo}
        tileOrigin="complete"
      />
    </>
  );
};
export default TileSingleView;
